import { useQuery } from '@tanstack/react-query';

import { getTimeOffBalances } from '../api/time-offs.api';
import { TIME_OFF_BALANCES_QUERY_KEY } from '../constants/time-offs-query-keys';

export const useTimeOffBalances = () => {
  return useQuery({
    queryKey: TIME_OFF_BALANCES_QUERY_KEY,
    queryFn: getTimeOffBalances,
    // TODO(OPS-1394): drop this `retry: false` when the real backend lands.
    //   Keeps the mock random-failure path observable instead of being masked by
    //   TanStack Query's default 3 retries.
    retry: false,
    // Balances only change on booking/cancellation (which invalidate the tree),
    // so serve cached data instead of refetching on every consumer mount.
    staleTime: 5000 * 60, // 5 minutes
  });
};
